export default {
  sales(state) {
    return state.sales;
  },
  salesDay(state) {
    return state.salesDay;
  },
  filters(state) {
    return state.filters;
  },
  loading(state) {
    return state.loading;
  },
  salesPaid(state) {
    return state.salesPaid;
  },
  salesTotal(state) {
    return state.salesTotal;
  },
  salesDesqualify(state) {
    return state.salesDesqualify;
  },
  salesDesqualifyDeb(state) {
    return state.salesDesqualifyDeb;
  },
  salesOccurrences(state) {
    // console.log('sales_ocurrency', state.sales)
    const countOccurences = (arr) =>
      arr.reduce((prev, curr) => {
        ((prev[curr.status] = ++prev[curr] || 1), prev);
      }, {});
    return countOccurences(state.sales);
  },
  plansByUtilityCompany: (state) => (utility_company) => {
    return state.plans.filter(
      (plan) => plan.utility_company == utility_company,
    );
  },

  filteredPlans: (state) => (params) => {
    if (params.plan_id) {
      return state.plans.filter((plan) => plan.id == params.plan_id);
    } else {
      return state.plans
        .filter((plan) => plan.status == "activated")
        .filter((plan) => plan.company == params.company)
        .filter((plan) => plan.utility_company == params.utility_company)
        .filter((plan) => plan.person_type == params.person_type);
    }
  },
};
